import { apiSlice } from "./apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["Notes"],
});

const notesApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getNotes: builder.query({
      query: () => "/notes",
      providesTags: ["Notes"],
    }),
    getSingleNote: builder.query({
      query: ({ note_id }) => `/note/${note_id}`,
      providesTags: ["Notes"],
    }),
    getSharedNotes: builder.query({
      query: () => "/sharednotes",
      providesTags: ["Notes"],
    }),
    getSharedNote: builder.query({
      query: ({ share_id }) => `/sharednote/${share_id}`,
      providesTags: ["Notes"],
    }),
    createNote: builder.mutation({
      query: (values) => ({
        url: "/note",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Notes"],
    }),
    updateNote: builder.mutation({
      query: ({ body, id }) => ({
        url: `/note/${id}`,
        method: "PUT",
        body: { ...body },
      }),
      invalidatesTags: ["Notes"],
    }),
    commentNote: builder.mutation({
      query: ({ comment, id }) => ({
        url: `/note/comment/${id}`,
        method: "POST",
        body: { comment },
      }),
      invalidatesTags: ["Notes"],
    }),
    shareNote: builder.mutation({
      query: ({ body, id }) => ({
        url: `/note/share/${id}`,
        method: "POST",
        body: { ...body },
      }),
      invalidatesTags: ["Notes"],
    }),
    unshareNote: builder.mutation({
      query: ({ id }) => ({
        url: `/note/share/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Notes"],
    }),
    deleteNote: builder.mutation({
      query: ({ id }) => ({
        url: `/note/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Notes"],
    }),
  }),
});

export const {
  useGetNotesQuery,
  useGetSharedNoteQuery,
  useGetSingleNoteQuery,
  useCommentNoteMutation,
  useCreateNoteMutation,
  useDeleteNoteMutation,
  useGetSharedNotesQuery,
  useShareNoteMutation,
  useUnshareNoteMutation,
  useUpdateNoteMutation,
} = notesApiSlice;
